let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jhuLr")).then(() => parcelRequire('b395l'));